import { render } from "./Table.vue?vue&type=template&id=5f65a976&scoped=true"
import script from "./Table.vue?vue&type=script&lang=js"
export * from "./Table.vue?vue&type=script&lang=js"

import "./Table.vue?vue&type=style&index=0&id=5f65a976&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-5f65a976"

export default script